import { render, staticRenderFns } from "./EditBlockNumberModal.vue?vue&type=template&id=ebcd014e&"
import script from "./EditBlockNumberModal.vue?vue&type=script&lang=js&"
export * from "./EditBlockNumberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports